// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__CCYE-","consentsList":"PatientConsents_consentsList__3WM_3","consentsListEmpty":"PatientConsents_consentsListEmpty__2p-QJ"};